import "./App.css";
import HomePage from "./homepage.js";
import React, { useRef } from "react";
import ReactToPrint from "react-to-print";
import theme from "./theme.js";
import { ThemeProvider } from "@mui/material";

function App() {
  return (
    <div>
      <ThemeProvider theme={theme}>
        <HomePage />
      </ThemeProvider>
    </div>
  );
}

export default App;
